import React from "react";

import { Form } from "antd";

import {
  ClientValue,
  Gpm,
  GpmThreshold,
  OnPriceChange,
  OnPriceRangeChange,
  PriceRange,
  PricingLevel,
  PricingType,
} from "../../data-types";
import { Fee } from "./fee";
import { FeeRange } from "./fee-range";

import styles from "./matter-editor-pricing-summary.module.css";

const { ["pricing-summary"]: pricingSummaryClass, container: containerClass } = styles as any;

export type MatterEditorPricingSummaryProps = {
  pricingType: PricingType;
  chosenPrice: number | null | PriceRange;
  suggestedPrice: number | null | PriceRange;
  gpm: Gpm | null;
  gpmThreshold: GpmThreshold;
  onChosenRangePriceChange: OnPriceRangeChange;
  onChosenPriceChange: OnPriceChange;
  onFixedPriceAlternativeChange?: OnPriceChange;
  fixedPriceAlternative?: number | null;
  pricingLevel: PricingLevel;
  currencySymbol: string;
  matterDetails: {
    title: string;
    externalReference: string;
    client?: ClientValue["name"];
    clientRef?: ClientValue["externalReference"];
  };
  isFeeEarnerLevelGpm: boolean;
};

export const MatterEditorPricingSummary: React.FC<MatterEditorPricingSummaryProps> = ({
  pricingType,
  chosenPrice,
  suggestedPrice,
  gpm,
  gpmThreshold,
  onChosenRangePriceChange,
  onFixedPriceAlternativeChange,
  onChosenPriceChange,
  fixedPriceAlternative,
  pricingLevel,
  currencySymbol,
  matterDetails,
  isFeeEarnerLevelGpm,
}) => {
  const isFeeRange = pricingType === PricingType.EstimatedRange;

  const pricingSummary = isFeeRange ? (
    <FeeRange
      isFeeEarnerLevelGpm={isFeeEarnerLevelGpm}
      currencySymbol={currencySymbol}
      gpmThreshold={gpmThreshold}
      chosen={chosenPrice as PriceRange}
      suggested={suggestedPrice as PriceRange}
      gpm={gpm}
      onChosenPriceChange={(arg) => {
        onChosenRangePriceChange(arg);
      }}
      onFixedPriceAlternativeChange={(arg) => {
        onFixedPriceAlternativeChange?.(arg);
      }}
      fixedPriceAlternative={fixedPriceAlternative as number | null}
      pricingType={pricingType}
      pricingLevel={pricingLevel}
    />
  ) : (
    <Fee
      isFeeEarnerLevelGpm={isFeeEarnerLevelGpm}
      currencySymbol={currencySymbol}
      gpmThreshold={gpmThreshold}
      chosen={chosenPrice as number | null}
      suggested={suggestedPrice as number | null}
      gpm={gpm}
      onChosenPriceChange={(arg) => onChosenPriceChange && onChosenPriceChange(arg)}
      pricingType={pricingType}
      pricingLevel={pricingLevel}
    />
  );

  return (
    <div className={pricingSummaryClass}>
      <Form labelCol={{ span: 7 }} wrapperCol={{ span: 17, offset: 1 }} className={containerClass}>
        <Form.Item label="Matter Title">{matterDetails.title} </Form.Item>
        {matterDetails.externalReference && (
          <Form.Item label="Matter Ref">{matterDetails.externalReference}</Form.Item>
        )}
        {matterDetails.client && <Form.Item label="Client">{matterDetails.client}</Form.Item>}
        {matterDetails.clientRef && (
          <Form.Item label="Client Ref">{matterDetails.clientRef}</Form.Item>
        )}
        {pricingSummary}
      </Form>
    </div>
  );
};
